import { useGetKbRecentlyViewed } from "controller";
import { KbFileSection } from "./KbSection";
import { Stack } from "@mui/material";
import { KbNoDataScreen } from "./KbNoDataScreen";

export const KbRecentlyVisited = () => {
  const { data: recentlyViewedFiles, isLoading } = useGetKbRecentlyViewed({});

  return (
    <Stack>
      {!isLoading && recentlyViewedFiles?.length === 0 ? (
        <KbNoDataScreen showCreateButton={false} />
      ) : (
        <Stack>
          {recentlyViewedFiles?.length !== 0 && (
            <KbFileSection
              files={recentlyViewedFiles || []}
              isSelectable={false}
            />
          )}
        </Stack>
      )}
    </Stack>
  );
};
